(function() {
  'use strict';

  // デバッグ情報を追加
  console.log('order-cut-cart-price.js が読み込まれました');

  // 価格表示を更新（簡略化版）
  async function updatePricesSimplified() {
    try {
      // カートAPIから商品情報を取得
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // レーザーカット商品を抽出
      const laserCutItems = cart.items.filter(item => 
        item.properties && item.properties._isOrderCut === 'true'
      );
      
      if (laserCutItems.length === 0) {
        console.log('レーザーカット商品が見つかりません');
        return;
      }
      
      console.log(`レーザーカット商品を${laserCutItems.length}個見つけました`);
      
      // 各商品の価格情報を集計
      let totalSubtotal = 0;
      const itemPrices = [];
      
      laserCutItems.forEach((item, index) => {
        const props = item.properties;
        console.log(`商品${index + 1}のプロパティ:`, props);
        
        // 保存された価格を取得（優先順位付き）
        let itemSubtotal = 0;
        let unitPrice = 0;
        let quantity = 1;
        
        // 注意: _customPrice, _subtotal, _actualPrice はすべて税抜き価格として保存されている
        // 1. _customPrice（最優先）
        if (props._customPrice) {
          itemSubtotal = parseFloat(props._customPrice);
          console.log(`商品${index + 1}: _customPriceから価格を取得: ${itemSubtotal}`);
        }
        // 2. _subtotal
        else if (props._subtotal) {
          itemSubtotal = parseFloat(props._subtotal);
          console.log(`商品${index + 1}: _subtotalから価格を取得: ${itemSubtotal}`);
        }
        // 3. _actualPrice
        else if (props._actualPrice) {
          itemSubtotal = parseFloat(props._actualPrice);
          console.log(`商品${index + 1}: _actualPriceから価格を取得: ${itemSubtotal}`);
        }
        
        // 単価を取得
        if (props._unitPrice) {
          unitPrice = parseFloat(props._unitPrice);
        }
        
        // 数量を取得
        if (props._quantity) {
          quantity = parseInt(props._quantity) || 1;
        } else if (props._actualQuantity) {
          quantity = parseInt(props._actualQuantity) || 1;
        }
        
        // 単価が未設定の場合は計算
        if (unitPrice === 0 && itemSubtotal > 0 && quantity > 0) {
          unitPrice = itemSubtotal / quantity; // 小数点以下も保持
        }
        
        // 小計が未設定の場合は計算
        if (itemSubtotal === 0 && unitPrice > 0 && quantity > 0) {
          itemSubtotal = unitPrice * quantity;
        }
        
        itemPrices.push({
          index: index,
          key: item.key,
          unitPrice: unitPrice,
          quantity: quantity,
          subtotal: itemSubtotal
        });
        
        totalSubtotal += itemSubtotal;
        
        console.log(`商品${index + 1}の価格情報:`, {
          unitPrice: unitPrice,
          quantity: quantity,
          subtotal: itemSubtotal
        });
      });
      
      console.log('全商品の税抜き合計:', totalSubtotal);
      
      // 消費税を計算（Shopifyと同じ方法：単価ベース）
      let totalWithTax = 0;
      itemPrices.forEach(item => {
        const unitPriceWithTax = Math.round(item.unitPrice * 1.1);
        totalWithTax += unitPriceWithTax * item.quantity;
      });
      const tax = totalWithTax - totalSubtotal;
      
      console.log('消費税:', tax);
      console.log('税込み合計:', totalWithTax);
      
      // DOM要素を更新
      updateDOMElements(itemPrices, totalSubtotal, tax, totalWithTax);
      
    } catch (error) {
      console.error('価格表示の更新に失敗しました:', error);
    }
  }

  // DOM要素を更新する関数
  function updateDOMElements(itemPrices, totalSubtotal, tax, totalWithTax) {
    try {
      // 各商品の価格を更新
      itemPrices.forEach(priceInfo => {
        // 商品要素を探す
        const itemElement = document.querySelector(`[data-item-key="${priceInfo.key}"]`) || 
                           document.querySelector(`[data-item-index="${priceInfo.index + 1}"]`);
        
        if (itemElement) {
          // 単価要素を更新
          const unitPriceElement = itemElement.querySelector('.unit-price');
          if (unitPriceElement) {
            unitPriceElement.textContent = formatMoney(priceInfo.unitPrice);
            unitPriceElement.style.fontWeight = 'bold';
            unitPriceElement.style.color = '#000';
            console.log(`商品${priceInfo.index + 1}の単価を更新:`, formatMoney(priceInfo.unitPrice));
          }
          
          // 合計価格要素を更新
          const linePriceElement = itemElement.querySelector('.line-price');
          if (linePriceElement) {
            linePriceElement.textContent = formatMoney(priceInfo.subtotal);
            linePriceElement.style.fontWeight = 'bold';
            linePriceElement.style.color = '#000';
            console.log(`商品${priceInfo.index + 1}の小計を更新:`, formatMoney(priceInfo.subtotal));
          }
        }
      });
      
      // カート全体の小計を更新（ラベルを壊さないよう数値のみが入る要素に限定）
      const subtotalElements = document.querySelectorAll('.totals__subtotal-value, .cart-subtotal__price, .cart__subtotal h3');
      subtotalElements.forEach(element => {
        element.textContent = formatMoney(totalSubtotal);
        element.style.color = '#000';
      });
      console.log('カート小計を更新:', formatMoney(totalSubtotal));

      // 消費税を表示（存在する場合）
      const taxElements = document.querySelectorAll('.cart__tax h3, .tax-amount');
      taxElements.forEach(element => {
        element.textContent = formatMoney(tax);
      });

      // 合計金額を更新
      const totalElements = document.querySelectorAll('.cart__total h3, .cart-total__price, .totals__total-value');
      totalElements.forEach(element => {
        element.textContent = formatMoney(totalWithTax);
        element.style.color = '#000';
      });
      console.log('税込み合計を更新:', formatMoney(totalWithTax));
      
      // 価格情報をストレージに保存（互換性のため）
      localStorage.setItem('_subtotal', totalSubtotal.toString());
      sessionStorage.setItem('_subtotal', totalSubtotal.toString());
      localStorage.setItem('_tax', tax.toString());
      sessionStorage.setItem('_tax', tax.toString());
      localStorage.setItem('_totalWithTax', totalWithTax.toString());
      sessionStorage.setItem('_totalWithTax', totalWithTax.toString());
      
    } catch (error) {
      console.error('DOM要素の更新に失敗しました:', error);
    }
  }

  // 金額をフォーマット
  function formatMoney(amount) {
    // PriceCalculator モジュールが利用可能な場合はそれを使用
    if (window.PriceCalculator && typeof window.PriceCalculator.formatPrice === 'function') {
      return window.PriceCalculator.formatPrice(amount);
    } else {
      // 従来の方法でフォーマット
      return '¥' + Math.round(amount).toLocaleString();
    }
  }

  // レーザーカート専用ページでの数量変更を無効化する関数
  function disableQuantityChange() {
    try {
      console.log('レーザーカート専用ページ：全数量変更を無効化します');

      // 数量入力欄を無効化
      const quantityInputs = document.querySelectorAll('input[name="quantity"], .quantity__input, .js-input-quantity-cart');
      console.log('数量入力欄を検索:', quantityInputs.length, '個見つかりました');
      
      quantityInputs.forEach(function(input) {
        try {
          input.setAttribute('readonly', 'true');
          input.style.backgroundColor = '#f5f5f5';
          input.style.color = '#666';
          input.style.cursor = 'not-allowed';
        } catch (error) {
          console.error('数量入力欄の無効化に失敗:', error);
        }
      });

      // 数量変更ボタンを無効化
      const quantityButtons = document.querySelectorAll('.quantity__button, .btn--qty, button[data-quantity]');
      console.log('数量変更ボタンを検索:', quantityButtons.length, '個見つかりました');
      
      quantityButtons.forEach(function(button) {
        try {
          button.setAttribute('disabled', 'true');
          button.style.opacity = '0.5';
          button.style.cursor = 'not-allowed';
        } catch (error) {
          console.error('数量変更ボタンの無効化に失敗:', error);
        }
      });

      // 注意書きを追加
      addQuantityChangeNotice();
      
      console.log('数量変更無効化処理が完了しました');
      
    } catch (error) {
      console.error('数量変更無効化処理中にエラーが発生しました:', error);
    }
  }

  // 専用レーザーカートページかどうかを判定
  function isLaserCutCartPage() {
    return window.location.pathname.includes('laser-cut-cart-page') ||
           document.querySelector('.laser-cut-cart') !== null;
  }

  // 数量変更の注意書きを追加
  function addQuantityChangeNotice() {
    try {
      // 既存の注意書きがあるかチェック
      const existingNotice = document.querySelector('.laser-cut-quantity-notice');
      if (existingNotice) {
        console.log('注意書きは既に存在します');
        return;
      }

      // 注意書きはテンプレートに静的に配置されているため、動的追加は不要
      console.log('数量変更の注意書きはテンプレートに含まれています');
      
    } catch (error) {
      console.error('注意書き追加中にエラーが発生しました:', error);
    }
  }

  // 初期化
  async function init() {
    try {
      if (!isLaserCutCartPage()) {
        console.log('専用レーザーカートページではありません。処理を終了します。');
        return;
      }

      console.log('専用レーザーカートページで初期化を開始します');

      // 数量変更を無効化（最優先）
      disableQuantityChange();

      // 価格表示を更新（簡略化版を使用）
      await updatePricesSimplified();

    } catch (error) {
      console.error('初期化中にエラーが発生しました:', error);
    }
  }

  // DOMの読み込みが完了したら初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('DOMContentLoaded イベントが発生しました');
      setTimeout(init, 100); // 少し遅延させて確実にDOM構築完了後に実行
    });
  } else {
    console.log('ドキュメントは既に読み込まれています');
    setTimeout(init, 100);
  }

  // ページが完全に読み込まれたら再度初期化（1回のみ）
  window.addEventListener('load', function() {
    setTimeout(init, 200);
  });
})();
